import { Typography } from '@mui/material';

import LegalPageLayout, {
  ContactLine,
  LegalSection,
  SupportEmailLink,
  useLegalIdentity,
} from './LegalPageLayout';

export default function SmsPrivacy() {
  const { party } = useLegalIdentity();

  return (
    <LegalPageLayout
      title="SMS Privacy Policy"
      crossLink={{ to: '/sms-terms', label: 'SMS Terms of Service' }}
    >
      <LegalSection title="1. Scope">
        {`This policy describes how ${party} collects, uses, and protects
        information in connection with its administrative SMS messaging program
        (the "Program"). It applies to the phone numbers and message content
        processed when you participate in the Program.`}
      </LegalSection>

      <LegalSection title="2. Information we collect">
        We collect the mobile phone number you enroll with, the content of messages you send to and
        receive from the Program (including any media attachments), message delivery metadata, and
        the enrollment details an administrator records for you (such as your name and work email
        address).
      </LegalSection>

      <LegalSection title="3. How we use it">
        This information is used solely to operate the Program: authenticating that a message comes
        from an enrolled participant, executing the administrative commands you send, delivering
        notifications and responses, maintaining an audit trail, and troubleshooting delivery
        issues. It is not used for advertising or marketing.
      </LegalSection>

      <LegalSection title="4. Sharing">
        <Typography variant="body1" color="text.secondary">
          <strong>
            No mobile information will be shared with third parties or affiliates for marketing or
            promotional purposes.
          </strong>{' '}
          Text messaging originator opt-in data and consent are not shared with any third parties,
          except for service providers acting on our behalf strictly to deliver the messages (e.g.,
          our cloud messaging provider), or where disclosure is required by law.
        </Typography>
      </LegalSection>

      <LegalSection title="5. Retention and security">
        Messages and enrollment records are retained as part of the Program&apos;s administrative
        audit trail for as long as operationally required, and are protected by access controls
        limiting them to authorized Tenspace personnel. When records are no longer needed they are
        deleted or de-identified.
      </LegalSection>

      <LegalSection title="6. Your choices">
        <Typography variant="body1" color="text.secondary">
          Reply <strong>STOP</strong> at any time to stop receiving messages, or{' '}
          <strong>HELP</strong> for assistance. You may also ask an administrator to remove your
          enrollment record entirely, or contact <SupportEmailLink /> with any privacy question or
          request.
        </Typography>
      </LegalSection>

      <LegalSection title="7. Changes to this policy">
        We may update this policy from time to time. The effective date above reflects the most
        recent revision.
      </LegalSection>

      <LegalSection title="8. Contact">
        <ContactLine />
      </LegalSection>
    </LegalPageLayout>
  );
}
